import React from "react";
import Header from "../Header";
import Button from "../Button";
import styles from "./AllSet.module.css";
import allSet from "./You're_all_set.svg";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAccount } from "utils/AccountInfoContext";

export function AllSet() {
  const { t } = useTranslation();
  const history = useHistory();
  const { subEntityData, cachedIBOInfo } = useAccount();
  const handleGoToClick = () => {
    history.push("/topics");
  };
  const handleHeaderClick = () => {
    history.push("/platinum-settings");
  };

  const pinLevelMapping = {
    2: "Platinum Settings",
    3: "Emerald Settings",
    4: "Diamond Settings",
  };

  const pinLevel = cachedIBOInfo?.PinLevel || 0;
  const headerText = pinLevelMapping[pinLevel];
  return (
    <div className={styles.container}>
      <div className={styles.headerContainer}>
        <Header header={t(headerText)} onClick={handleHeaderClick} />
      </div>
      <div className={styles.content}>
        <img src={allSet} alt="You're All Set" />
        <span className={styles.detailText}>
          {t("Check the business entity")}
        </span>
        <div className={styles.buttonsContainer}>
          <Button
            // onClick={handleGoToClick}
            buttonText={t("Go to Business Entity Page")}
            onClick={() => history.push("/platinum-settings")}
          />
        </div>
      </div>
    </div>
  );
}
